import React, { useEffect, useState, Suspense } from 'react'
import { useParams, Link, useHistory } from 'react-router-dom'
import Container from 'elements/Container'
import {
  StatsWrapper,
  PageTitle,
  Grid,
  Title,
  Divider,
  NftLogo,
  EthIcon,
  PriceChange,
  InfoText,
  InfoTextBold
} from './styled'
import Flex from 'elements/Flex'
import { useSelector, useDispatch } from 'react-redux'
import NftStatChart from './NftStatChart'
import { selectNftStat } from 'state/nftstat/slice'
import Loader from 'components/Loader'
import { formatNumberFixed, formatNumber } from 'utils/formatNumber'
import fetchNftStatBySlug from 'state/nftstat/actions/fetchNftBySlug'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import Favorite from 'pages/NftStats/Favorite'
import DailyFilter from './Filters/DailyFilter'
import Fallback from 'components/Fallback'

function NftStatDetail() {
  const dispatch = useDispatch()
  const { slug } = useParams()
  const nftStat = useSelector(selectNftStat)
  const data = nftStat.items[slug]
  const [isIncreasing, setIsIncreasing] = useState(false)
  const history = useHistory()

  useEffect(() => {
    if (!data) {
      dispatch(fetchNftStatBySlug(slug))
    }

    setIsIncreasing(data?.stats?.sevenDayChange >= 0)
  }, [dispatch, data, slug])

  return (
    <Container>
      <PageTitle onClick={history.goBack}>
        <FontAwesomeIcon icon={faChevronLeft} /> NFT Stats
      </PageTitle>
      <StatsWrapper>
        {nftStat.status === 'failed' && !data && (
          <h4 style={{ textAlign: 'center' }}>
            404: Data not found!. <Link to="/nftstats">Back to lists</Link>
          </h4>
        )}
        {nftStat.status === 'loading' && !data && (
          <div style={{ textAlign: 'center' }}>
            <Fallback height="50vh" />
          </div>
        )}
        {data && (
          <>
            <Grid>
              <div>
                <Flex alignItems="center" gap={14}>
                  <Flex alignItems="center" gap={16}>
                    <NftLogo src={data.logo} alt={data.name} />
                    <Title as="h2">{data.name}</Title>
                  </Flex>
                  <Favorite slug={slug} />
                </Flex>
                <div style={{ marginTop: '1rem' }}>
                  <div style={{ fontSize: '14px' }}>Links:</div>
                  <Flex style={{ fontSize: '14px', marginTop: '.5rem' }} gap={16}>
                    <a
                      href={`https://opensea.io/collection/${slug}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: 'green', textDecoration: 'none' }}
                    >
                      Opensea
                    </a>
                  </Flex>
                </div>
              </div>
              <div>
                <Flex alignItems="center" gap={14}>
                  <Flex alignItems="center" gap={8} style={{ fontWeight: 500 }}>
                    <EthIcon />
                    {data.floorPrice ? formatNumberFixed(Number(data.floorPrice)) : '--'}
                  </Flex>
                  <PriceChange isIncreasing={isIncreasing}>{formatNumberFixed(data.stats.sevenDayChange)}%</PriceChange>
                </Flex>
                <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                  <InfoText>Owners</InfoText>
                  <InfoTextBold>{formatNumber(data.stats.numOwners)}</InfoTextBold>
                </div>
                <Flex gap={32}>
                  <div>
                    <InfoText>Market Cap</InfoText>
                    <InfoTextBold>{formatNumberFixed(data.stats.marketCap)}</InfoTextBold>
                  </div>
                  <div>
                    <InfoText>Total Volume</InfoText>
                    <InfoTextBold>{formatNumberFixed(data.stats.totalVolume)}</InfoTextBold>
                  </div>
                </Flex>
              </div>
            </Grid>
            <Divider />
            <Title style={{ fontSize: '16px' }}>{data.name} to ETH Chart</Title>
            <DailyFilter slug={slug} />
            <div style={{ marginTop: '1rem' }}>
              {nftStat.status === 'loading' && !data?.days?.[nftStat.filter] ? (
                <Flex style={{ height: '300px' }} alignItems="center" justifyContent="center">
                  <Fallback />
                </Flex>
              ) : (
                <Suspense fallback={null}>
                  <NftStatChart days={data.days[nftStat.filter]} />
                </Suspense>
              )}
            </div>
          </>
        )}
      </StatsWrapper>
    </Container>
  )
}

export default NftStatDetail
